/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

function histogramIconDirective() {
    return {
        restrict: 'E',
        scope: {},
        template: require('./histogramIconView.html'),
    };
}

module.exports = histogramIconDirective;
